module.exports = __webpack_public_path__ + "static/win33-63dc57f2aeb25a9c35a411561298a619.png";